<template>
  <!-- 须加上@click.stop 防止冒泡 -->
  <div style="width: 740px;" @click.stop>
    <div class="user_portrait" v-for="useObj in users" :key="useObj.name">
      <div class="portrait_name">{{ useObj.name }}</div>
      <div :class="['list_ctn', (useObj.list && useObj.list.length > 0) ? 'not_blank' : '']">
        <div class="label_item" v-for="obj in useObj.list" :key="obj.name">
          {{ obj.name }}
          <i class="el-icon-circle-close icon_delete" @click="delUserObj(useObj.list, obj, useObj.profiles)"></i>
        </div>
        <el-popover
          style="padding: 0;height: 330px;"
          popper-class="cprplus_label_list"
          trigger="click"
          :placement="useObj.place"
          v-model="useObj.show">
          <div slot="reference" class="add" @click="addClick(useObj)">点击添加标签</div>
          <div class="title">标签种类
            <div class="fr" style="margin-right: 10px;">
              <el-popover trigger="hover" placement="bottom-end">
                <i slot="reference" class="el-icon-question"></i>
                <div>
                  <div class="title_help_pop">
                    <div>温馨提示</div>
                    <p>手提物：人物手中拎着塑料袋</p>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
          <div class="label_ctn" v-for="{ name, labels } in useObj.profiles" :key="name">
            <div class="fl">{{ name }}</div>
            <div class="fr">
              <span
                v-for="d in labels"
                :key="d.value"
                :class="{ 'check': d.check }"
                @click="toggleClick(d, useObj, labels)">
                {{ d.name }}
                <i v-if="d.check" class="el-icon-circle-close icon_delete"></i>
              </span>
            </div>
            <div class="clear"></div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CprPlusLabelPop',
  props: {
    value: Array
  },
  data () {
    return {
      users: [],
      initUsers: [] // 深拷贝users物体列表原始数据，供取消操作还原使用
    }
  },
  computed: {
    labelListMap () {
      return this.$store.state.label.codeMap
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) { // 取消展开之后 选中确定的数据状态
        this.handleValueChange(v)
      }
    },
    labelListMap: {
      immediate: true,
      handler (v) {
        // 数据初始化,如果已经初始化过就不再执行
        if (this.initUsers.length > 0) return
        this.initBlankList()
        // 当组件销毁时 再次点击会重新初始化原始列表数据，会置空当前展示内容
        // 再次执行 handleValueChange 更新为外部传入的 value 数据
        this.handleValueChange(this.value)
      }
    }
  },
  methods: {
    addClick (data) { // 点击添加时 关闭其他弹窗
      this.users.forEach(el => {
        if (el.name != data.name && el.show) el.show = false
      })
    },
    // 外部父级可能存在 @click.stop 导致点击父级空白区 这里的弹窗关闭不了
    // 供父级调用 关闭弹窗
    closePopovers () {
      this.users.forEach(el => {
        if (el.show) el.show = false
      })
    },
    initProfileList () {
      // let sortMap = this.$store.state.label.sortMap
      // let sortList = type => sortMap && sortMap[type] ? this.labelListInit(sortMap[type]) : []
      // let list = [
      //   { name: '性别', labels: sortList('SEX'), type: 'SEX' },
      //   { name: '年龄', labels: sortList('AGE'), type: 'AGE' },
      //   { name: '衣着', labels: sortList('CLOTHING'), type: 'CLOTHING' },
      //   { name: '职业', labels: sortList('PEOPLE_TYPE'), type: 'PEOPLE_TYPE' },
      //   { name: '头部', labels: sortList('HEAD'), type: 'HEAD' },
      //   { name: '脸部', labels: sortList('FACE'), type: 'FACE' },
      //   { name: '特殊', labels: sortList('SPECIAL'), type: 'SPECIAL' },
      //   { name: '行为', labels: sortList('BEHAVIOUR'), type: 'BEHAVIOUR' }
      // ]
      // return JSON.parse(JSON.stringify(list))

      // 用户画像相关标签,由本地写死改为从store中获取并作格式化方便标签扩展(20230504)
      const person = this.$store.state.label.list.filter(e => e.kind === 'PERSON')
      if (person && person.length) {
        const list = person[0].groups.map(({ group, groupName, labels }) => {
          return { name: groupName, labels: this.labelListInit(labels), type: group }
        })
        // 深拷贝各个数据以防各个画像之间相互影响, 数据虽然相同，但是用同一份数据 会导致 check 状态联动
        // 也可以 popper 的 show 事件中增加对每个物体选择的属性列表对应的数据check状态 重置到统一弹窗中
        return JSON.parse(JSON.stringify(list))
      }
      return []
    },
    labelListInit (arr) {
      return JSON.parse(JSON.stringify(arr)).map(k => {
        this.$set(k, 'check', false)
        return k
      })
    },
    // 初始化空模板列表,方便取消操作时数据回到初始状态
    initBlankList () {
      this.initUsers = [
        { name: '画像A', list: [], profiles: this.initProfileList(), place: 'right', show: false },
        { name: '画像B', list: [], profiles: this.initProfileList(), place: 'right', show: false },
        { name: '画像C', list: [], profiles: this.initProfileList(), place: 'right', show: false },
        { name: '画像D', list: [], profiles: this.initProfileList(), place: 'left', show: false },
        { name: '画像E', list: [], profiles: this.initProfileList(), place: 'left', show: false }
      ]
      this.users = JSON.parse(JSON.stringify(this.initUsers))
    },
    handleValueChange (v) {
      v = v || this.value
      let blankList = JSON.parse(JSON.stringify(this.initUsers))
      if (v && v.length) {
        // 填充 profiles 数据 以及 各个标签的check状态
        let data = JSON.parse(JSON.stringify(v)).map(el => {
          let checkCodes = el.list.map(el => el.code)
          let pros = this.initProfileList()
          pros.forEach(ele => {
            ele.labels.forEach(label => {
              label.check = checkCodes.indexOf(label.code) > -1 ? true : false
            })
          })
          el.profiles = pros
          return el
        })
        if (data.length < 5) {
          let len = data.length
          data.splice(len, 0, ...blankList.slice(len))
        }
        this.users = data
      } else {
        this.users = blankList // 当value为空数组时还原当前展示列表users为初始模板数据,深拷贝防止数据污染
      }
    },
    // 当前点击的标签 当前画像 当前点击标签所属group下的label列表
    toggleClick (t, userObj, labelList) {
      t.check = !t.check
      const status = t.check // 记录下选中状态

      // 只能选一个情况 这里先去除掉userObjList当前同类 group 所选择过的内容（如果存在的话）,labelList中check都重置为false
      // 如果可以多选，此处可注释
      this.delCodeItemInArr(userObj.list, t, 'group')
      labelList.forEach(el => { if (el.check) el.check = false })
      t.check = status

      /**
       ** 行为标签与其他标签互斥,选中标签按顺序展示(20230508)
       */
      if (t.group === 'BEHAVIOUR') {
        userObj.list = labelList.filter(e => e.check)
      } else {
        userObj.list = userObj.profiles.filter(e => e.type !== 'BEHAVIOUR').reduce((res, cur) => {
          const checks = cur.labels.filter(e => e.check) || []
          return res.concat(checks)
        }, [])
      }

      this.update()
    },
    delCodeItemInArr (arr, item, key) { // 删除列表中 key 值是 item.key 的内容项
      let idx = arr.map(el => el[key]).indexOf(item[key])
      if (idx > -1) arr.splice(idx, 1)
      return idx // 返回索引供外部使用
    },
    delUserObj (userObjList, item, profiles) { // 当前物体的已选label列表  当前删除的标签code 当前物体对应的弹窗标签列表  当前删除的标签context
      // 数据中删除此项
      // userObjList.splice(list.map(el => el.context).indexOf(context), 1) // 如果同一类可多选的需求下  可以根据 context 来删除处理
      this.delCodeItemInArr(userObjList, item, 'group')
      // 更新当前物体对应弹窗数据的勾选状态
      profiles.filter(el => el.type == item.group).forEach(element => {
        element.labels.forEach(ele => {
          if (ele.check) ele.check = false // 删除之后取消
        })
      });
      this.update()
    },
    // 更新数据
    update () {
      this.$emit('input', this.users)
    }
  }
}
</script>

<style lang="scss" scoped>
.user_portrait {
  float: left;
  width: 120px;
  line-height: 30px;
  color: #282729;
  text-align: center;
  margin: 0 14px;
  position: relative;
  font-size: 12px;
  font-weight: 400;
  &::after {
    content: '或';
    position: absolute;
    right: -20px;
    top: 45px;
  }
  &:last-child {
    &::after {
      content: '';
    }
  }
  .portrait_name {
    line-height: 42px;
  }
  .list_ctn {
    border: 1px dashed #E9E9E9;
    &.not_blank {
      border: 1px solid #FF3973;
    }
    .label_item {
      position: relative;
      box-shadow: 0 1px 0 0 #EAEBF0;
      .icon_delete {
        cursor: pointer;
        position: absolute;
        top: -5px;
        right: -7px;
        background: #fff;
        color: #FF3973;
      }
    }
  }
  .add {
    color: #999;
    cursor: pointer;
  }
}
.title_help_pop {
  font-size: 12px;
  div {
    font-weight: bold;
  }
  p {
    color: #666;
    line-height: 30px;
  }
}
</style>
<style lang="scss">
.cprplus_label_list {
  margin-left: 20px!important;
  .title {
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid #E9E9E9;
    margin: -12px -12px 15px;
    .el-icon-question {
      cursor: pointer;
    }
  }
  .label_ctn {
    line-height: 30px;
    .fl {
      width: 70px;
      text-align: center;
    }
    .fr {
      width: calc(100% - 70px);
      span {
        text-align: center;
        display: inline-block;
        padding: 0 10px;
        margin: 0 5px 15px;
        background: #F5F5F5;
        border: 1px solid #F5F5F5;
        border-radius: 2px;
        cursor: pointer;
        position: relative;
        font-size: 12px;
        user-select: none;
        &.check {
          border: 1px solid #FF3973;
        }
      }
    }
    .icon_delete {
      cursor: pointer;
      position: absolute;
      top: -5px;
      right: -6px;
      background: #fff;
      color: #FF3973;
    }
    .clear {
      clear: both;
    }
  }
}
</style>
